/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import type { TerminalField as TerminalFieldConfig } from "./providerConfig";

type TerminalFieldProps = {
  field: TerminalFieldConfig;
  value: string | number | undefined;
  onUpdate: (value: string) => void;
};

/** One provider-defined input (terminal ID, serial, credentials, pairing code). */
export const TerminalField = defineComponent<TerminalFieldProps>({
  name: "TerminalField",
  props: ["field", "value", "onUpdate"],
  setup(props) {
    const { t } = useLocalization();

    return () => {
      const { field } = props;
      return (
        <label class="form-control w-full">
          <div class="label">
            <span class="label-text text-sm font-medium text-base-content/80">
              {t(field.labelKey)}
            </span>
          </div>
          <input
            type={field.type || "text"}
            value={props.value === undefined ? "" : String(props.value)}
            maxlength={field.otp ? 6 : undefined}
            autocomplete={field.otp ? "one-time-code" : "off"}
            autocapitalize={field.otp ? "characters" : undefined}
            spellcheck={false}
            onInput={(e: Event) =>
              props.onUpdate((e.target as HTMLInputElement).value)
            }
            placeholder={field.placeholderKey ? t(field.placeholderKey) : ""}
            class={`input input-bordered w-full ${field.mono ? "font-mono" : ""} ${
              field.otp
                ? "h-14 text-center text-2xl uppercase tracking-[0.5em] placeholder:text-base placeholder:tracking-normal"
                : ""
            }`}
          />
        </label>
      );
    };
  },
});
